import React, {useEffect, useState} from 'react';
import useStore from "../Store";
import ConstructionSiteApi from "../API/constructionSiteApi";
import GoAroundApi from "../API/goAroundApi";
import {MainDiv, LineDiv, Text, SectionDiv, SelectorsDiv, SelectorDiv, ButtonsDiv, Button} from "./design.js"
import ConstructionSiteProgress from "./ConstructionSite/ConstructionSiteProgress";
import ConstructionSiteDayWorks from "./ConstructionSiteDayWorks";
import ToDo from "./ToDo";
import PhotoProgressWorks from "./PhotoProgressWorks";
import HouseSelection from "../Statistic/HouseSelection";


const GoAroundMain = () => {
    const Houses=useStore((state)=>state.Houses.Location1);
    const Floors=useStore((state)=>state.Floors);
    const [selectedGoal, setSelectedGoal]=useState(null);
    const [Data, setData]=useState({status:"local", frontId:Date.now()});
    const [selectedHouse, setSelectedHouse]=useState(null)
    const [selectedFloor, setSelectedFloor]=useState(null)

    useEffect( ()  => {
        const LocalData=JSON.parse(localStorage.getItem("Data"));
        // console.log (LocalData)
        if(LocalData){
            if(LocalData.status === "local")
            if(window.confirm("There is local saved data. Want you to use this data?"))
                setData({...LocalData})
        }
    }, []);


    async function saveData() {
        try {
            const result = await GoAroundApi.addGoAroundData(
                1,
                Data
            );

            if (result.Status) {
                const updated = {
                    ...Data,
                    status: "saved"
                };

                setData(updated);

                localStorage.setItem(
                    "Data",
                    JSON.stringify(updated)
                );

                alert("Data was saved");
            } else {
                alert("Data could not be saved");
            }
        } catch (error) {
            console.error("Save error:", error);
            alert("Error while saving data");
        }
    }


    function changeFloor(event){
        let Floor=event.currentTarget.id;
        let TempData=Data;

        if(selectedFloor === Floor) {
            setSelectedFloor(null)
            return;
        }
        if(!TempData[selectedHouse].Floors[Floor])
            TempData[selectedHouse].Floors[Floor]={WorkTypes:{}, ProgressWorkTypes:{}};

        localStorage.setItem("Data",JSON.stringify(TempData))
        setSelectedFloor(Floor)
        setData({...TempData})
    }
    function changeGoal(event){
        const Goal=event.currentTarget.id;
        setSelectedGoal(Goal)
    }
    function Goal(Goal){
        switch(Goal) {
            case "ConstructionSiteDayWorks":
                return (<ConstructionSiteDayWorks
                    Data={Data}
                    setData={setData}
                    selectedHouse={selectedHouse}
                    selectedFloor={selectedFloor}
                />)
                break;
            case "ConstructionSiteProgress":
                return (<ConstructionSiteProgress
                    Data={Data}
                    setData={setData}
                    selectedHouse={selectedHouse}
                    selectedFloor={selectedFloor}
                />)
            case "ToDo":
                return(
                    <ToDo
                        setSelectedGoal={setSelectedGoal}
                        House={selectedHouse}
                        Floor={selectedFloor}
                    />
                );
            case "Camera":
                return(
                    <PhotoProgressWorks
                        house={selectedHouse}
                        floor={selectedFloor}
                        setSelectedGoal={setSelectedGoal}
                    />
                )
        }
    }
    useEffect(() => {
        setSelectedFloor(null);
        setSelectedGoal(null);

        if (!selectedHouse) return;

        setData(prev => {
            if (prev[selectedHouse]) return prev;

            const updated = {
                ...prev,
                [selectedHouse]: { Floors: {} }
            };

            localStorage.setItem(
                "Data",
                JSON.stringify(updated)
            );

            return updated;
        });
    }, [selectedHouse]);
     // console.log(Floors)

    return (
        <MainDiv>
            <HouseSelection
                houses={Houses}
                selectedHouse={selectedHouse}
                setSelectedHouse={setSelectedHouse}
            />

            <SectionDiv
                $visible={Boolean(selectedHouse)}
                $clickable={Boolean(selectedHouse)}
            >
                {Floors.map((floor) => {
                    const selected = selectedFloor === floor;

                    const hasData = Boolean(
                        selectedHouse &&
                        Data[selectedHouse]?.Floors?.[floor]
                    );

                    return (
                        <LineDiv
                            key={floor}
                            id={floor}
                            $selected={selected}
                            onClick={changeFloor}
                        >
                            <input
                                type="checkbox"
                                checked={selected}
                                readOnly
                                tabIndex={-1}
                            />

                            <Text>{floor}</Text>

                            {hasData && (
                                <span style={{
                                    color: "#019A32",
                                    fontWeight: 700
                                }}>
                                +
                            </span>
                            )}
                        </LineDiv>
                    );
                })}
            </SectionDiv>

            <SelectorsDiv $visible={Boolean(selectedFloor)}>
                <SelectorDiv
                    id="ConstructionSiteDayWorks"
                    $active={
                        selectedGoal === "ConstructionSiteDayWorks"
                    }
                    onClick={changeGoal}
                >
                    Bautagebuch
                </SelectorDiv>

                <SelectorDiv
                    id="ConstructionSiteProgress"
                    $active={
                        selectedGoal === "ConstructionSiteProgress"
                    }
                    onClick={changeGoal}
                >
                    Ergebnis
                </SelectorDiv>

                <SelectorDiv
                    id="ToDo"
                    $active={selectedGoal === "ToDo"}
                    onClick={changeGoal}
                >
                    ToDo
                </SelectorDiv>
            </SelectorsDiv>

            {Goal(selectedGoal)}

            <ButtonsDiv $visible={Boolean(selectedHouse)}>
                {selectedFloor && (
                    <Button
                        id="Camera"
                        $secondary
                        onClick={changeGoal}
                    >
                        📷 Photo
                    </Button>
                )}

                <Button onClick={saveData}>
                    Speichern
                </Button>
            </ButtonsDiv>
        </MainDiv>
    );

};

export default GoAroundMain;